import gql from 'graphql-tag'

export const MessageProgramsTableQuery = gql`
	query messageProgramsTableQuery {
		messagePrograms {
			_id
			name
			team {
				_id
				path
				n
			}
			zones {
				_id
				device {
					_id
				}
			}
		}
	}
`

export const MessageProgramDetailsQuery = gql`
	query fetchMessageProgram($id: String!) {
		messageProgramById(_id: $id) {
			_id
			name
			teamId
			team {
				_id
				path
				n
			}
			crossfade
			musicVolume
			mediaIds
			medias {
				_id
				name
				created
				optimizedMono {
					duration
				}
				optimizedStereo {
					duration
				}
			}
			schedule
			commentCount
			devicesCount
			ownerId
			createdBy {
				date
				name
			}
			updatedBy {
				date
				name
			}
			owner {
				_id
				firstName
				lastName
			}
		}
	}
`

export const MessageProgramDetailsDevicesQuery = gql`
	query fetchMessageProgramWithDevice($id: String!) {
		messageProgramById(_id: $id) {
			_id
			teamId
			zones {
				_id
				name
				device {
					_id
					name
					nickname
					OS
					onlineDate
					onlineState
					lastConnection
					dlState
					contentUpdated
					zones {
						_id
						name
						playState
						program {
							_id
							updatedBy {
								date
								name
							}
						}
						messagePrograms {
							_id
							updatedBy {
								date
								name
							}
						}
					}
				}
			}
		}
	}
`

export const MediaQuery = gql`
	query fetchTeamMediaTree($teamId: String!) {
		teamMediaTree(teamId: $teamId) {
			tree
		}
	}
`

// devices playing the message program, to show the scheduler "now" in their timezone
export const MessageProgramScheduleDevicesQuery = gql`
	query messageProgramScheduleDevices($id: String!) {
		messageProgramById(_id: $id) {
			_id
			zones {
				_id
				device {
					_id
					name
					nickname
					timeZone
				}
			}
		}
	}
`
